<template>
  <iRow align="center">
    <SplashWrapper
      :hide-buttons="true"
      title="Reset Password Error"
      :narrow-page="true"
    >
      <iRow>
        <iRow align="center">
          <iDisplayText variant="small">
            {{ resetPasswordError.label }}
          </iDisplayText>
        </iRow>
        <iRow align="center">
          <iParagraph text-align="center">
            {{ resetPasswordError.message }}
          </iParagraph>
        </iRow>
      </iRow>
    </SplashWrapper>
  </iRow>
</template>

<script>
import { Enum } from "@vcl";

export default {
  name: "ResetPasswordError",
  props: {
    userId: {
      type: Number,
      required: true,
    },
    reason: {
      type: [Enum, String],
      required: true,
      options: ["expired", "invalid"],
      validator: value => ["expired", "invalid"].includes(value),
    },
  },
  computed: {
    resetPasswordError() {
      switch (this.reason) {
        case "expired":
          return {
            label: "Expired Reset Link",
            message: "Expired reset link. Please check your email for a new reset link.",
          };
        case "invalid":
          return {
            label: "Invalid Reset Link",
            message: "Invalid reset link. Please request a new password reset email.",
          };
        default:
          return {
            label: "Unknown Error",
            message: "An unknown error occurred. Please try again.",
          };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
